import React, { useEffect } from "react"
import { track } from "../../analytics/mixpanel"
import { ErrorBoundary } from "../ErrorBoundary"
import { PartnerOnboardingWizard } from "./PartnerOnboardingWizard"

export default function OnboardingApp({ createPath, connectPath, copy }) {
  useEffect(() => {
    track("Partner Onboarding Started", { path: window.location.pathname })
  }, [])

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-white dark:bg-gray-900 antialiased">
        <PartnerOnboardingWizard createPath={createPath} connectPath={connectPath} copy={copy} />
      </div>
    </ErrorBoundary>
  )
}
